<template>
  <div>
    <LoadingBar ref="loadingBar" />
    <div class="mt-[3px]">
      <div class="container mx-auto h-screen">
        <div class="flex flex-row justify-center">
          <TheAside />
          <div class="flex flex-col md:flex-row justify-center max-sm:w-full ">
            <div class="relative w-full sm:w-600 h-full border-x border-gray-200 dark:border-gray-700 ">
              <div
                class="flex justify-between items-center  px-2 py-2 sm:py-3  sticky z-50 top-[3px] bg-white  dark:bg-dim-900 noprint select-none border-b border-gray-200 dark:border-gray-700">
                <div class="flex gap-2 items-center ">
                  <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                    <button v-if="isInternalPage" @click="$router.go(-1)" class="text-gray-900 dark:text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-chevron-right w-6 h-6" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </button>
                  </transition>
                  <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                    <h2 class="text-gray-800 dark:text-gray-100 font-sm hidden xs:block">{{ pageTitle }}</h2>
                  </transition>
                </div>
                <router-link to="/fa" class="flex justify-center xl:justify-start gap-3 hover:opacity-75 xs:hidden">
                  <img src="@/assets/images/logo.png" class="w-10" alt="" />
                  <img src="@/assets/images/text-logo.png" class="object-contain w-28" alt="" />
                </router-link>
                <div class="flex gap-2 items-center">
                  <button @click="toggleDropdown">
                    <svg class="w-6 h-6 text-gray-600 dark:text-white" xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d=" M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z ">
                      </path>
                    </svg>
                  </button>
                  <div v-show="dropdownVisible" id="dropdownAvatarName"
                    class="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-dim-900 dark:divide-gray-600 absolute max-lg:top-[54px] lg:top-[62px] left-1">
                    <div class="px-4 py-3 text-sm text-gray-900 dark:text-white">
                      <div class="truncate">انتخاب زبان</div>
                    </div>
                    <ul class="py-2 text-sm text-gray-700 dark:text-gray-200">
                      <li>
                        <a href="#" v-for="item in language" :key="item.id"
                          class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-dim-700 dark:hover:text-white"
                          @click="setLanguage(item)">
                          {{ item.title }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" value="" class="sr-only peer" @change="toggleDarkMode"
                      ref="darkModeCheckbox" />
                    <div
                      class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-greenrefah">
                    </div>
                  </label>

                </div>
              </div>
              <div class="pb-0 sm:pb-0 ">
                <router-view v-slot="{ Component, route }">
                  <transition name="fade">
                    <component :is="Component" :key="route.path" />
                  </transition>
                </router-view>
              </div>
            </div>
            <div :class="{ block: $route.path === '/fa', 'max-sm:hidden': $route.path !== '/fa' }">
              <TheSeccoundAside />
            </div>
          </div>
        </div>
      </div>
      <div
        class="xs:hidden fixed bottom-0 left-0 z-50 w-full h-12 bg-white dark:bg-dim-900 border-t border-gray-200 dark:border-gray-700 noprint">
        <div class="grid h-full max-w-lg grid-cols-5 mx-auto font-medium text-center">
          <router-link to="/fa"
            :class="{ 'text-primary': $route.path === '/fa', 'text-gray-800 dark:text-white': $route.path !== '/fa' }">
            <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 22 22">
                <path stroke="currentColor" stroke-width="1.833"
                  d="m11.092 2.973 8.25 5.919v10.266h-4.859v-3.941c0-1.79-1.51-3.3-3.3-3.3-1.79 0-3.3 1.51-3.3 3.3v3.941H3.025V8.76l8.067-5.787Z">
                </path>
              </svg>
            </button>
          </router-link>
          <router-link to="/fa/news"
            :class="{ 'text-primary': $route.path === '/fa/news', 'text-gray-800 dark:text-white': $route.path !== '/fa/news' }">
            <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor"
                  d="m8.8 16.1 3.6 6.2c.2.4.8.6 1.2.3l3.1-1.8c.4-.2.6-.8.3-1.2L13.8 14l4.5-.3c.5 0 .9-.5.8-.9 0-.1-.1-.3-.1-.4L12.8 1.6c-.2-.4-.8-.6-1.2-.3l-.3.3-3.2 4.8-2.9 1.7c-2.1 1.2-2.9 3.9-1.6 6 1 1.9 3.2 2.7 5.2 2Zm6.3 3.7-1.5.9-3.1-5.4 1.5-.9 3.1 5.4Zm-9-10.2 3.1-1.8.3-.3L12 3.8l4.8 8.3-4.5.3c-.1 0-.3 0-.4.1l-3.1 1.8c-1.3.7-2.9.2-3.6-1-.8-1.4-.3-3 .9-3.7Zm14.4-5.2c1 1.7.4 3.9-1.3 4.9-.4.2-1 .1-1.2-.3-.2-.4-.1-1 .3-1.2.9-.5 1.1-1.6.7-2.4-.5-.9-1.6-1.1-2.4-.7-.4.2-1 .1-1.2-.3-.2-.4-.1-1 .3-1.2 1.6-1.1 3.8-.5 4.8 1.2Z">
                </path>
              </svg>
            </button>
          </router-link>
          <router-link to="/fa/media"
            :class="{ 'text-primary': $route.path === '/fa/media', 'text-gray-800 dark:text-white': $route.path !== '/fa/media' }">
            <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
              <svg class="h-6 w-6" fill="none" viewBox="0 0 28 28">
                <path fill="currentColor" fill-rule="evenodd"
                  d="m10.945 17.28 7.963-4.513a.666.666 0 0 0 0-1.164l-7.963-4.512c-.457-.259-1.028.065-1.028.582v9.024c0 .518.571.841 1.028.582Zm4.257-5.095-2.951-1.672v3.345l2.951-1.673Z"
                  clip-rule="evenodd"></path>
                <path fill="currentColor" fill-rule="evenodd"
                  d="M3.996 2.625A2.552 2.552 0 0 0 1.46 5.177V18.74a2.552 2.552 0 0 0 2.552 2.552h19.98a2.552 2.552 0 0 0 2.551-2.553V5.178a2.552 2.552 0 0 0-2.537-2.552H3.996Zm-.204 2.847c0-.282.228-.514.514-.514h19.39c.285 0 .513.232.513.514v12.95c0 .281-.227.536-.513.536H4.306c-.286 0-.514-.255-.514-.536V5.472Z"
                  clip-rule="evenodd"></path>
                <path fill="currentColor" d="M8.165 25.375v-2.333h11.669v2.333H8.165Z"></path>
              </svg>
            </button>
          </router-link>
          <router-link to="/fa/sound"
            :class="{ 'text-primary': $route.path === '/fa/sound', 'text-gray-800 dark:text-white': $route.path !== '/fa/sound' }">
            <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-mic w-6 h-6" viewBox="0 0 16 16">
                <path
                  d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5">
                </path>
                <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3"></path>
              </svg>
            </button>
          </router-link>
          <router-link to="/fa/asideHome"
            :class="{ 'text-primary': $route.path === '/fa/asideHome', 'text-gray-800 dark:text-white': $route.path !== '/fa/asideHome' }">
            <button type="button" class="h-full inline-flex flex-col items-center justify-center px-5">
              <svg data-v-4686fdc4="" xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-mail w-6 h-6" width="18" height="18" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path data-v-4686fdc4=""
                  d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z">
                </path>
              </svg>
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TheAside from "@/containers/TheAside.vue";
import TheSeccoundAside from "./TheSeccoundAside.vue";
import LoadingBar from "@/components/LoadingBar.vue";
export default {
  name: "TheContainer",
  components: {
    TheAside,
    TheSeccoundAside,
    LoadingBar,
  },
  data() {
    return {
      languageId: null,
      dropdownVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      language: "baseX/language",
    }),
    pageTitle() {
      return this.$route.meta.title || "حزب رفاه ملی افغانستان";
    },
    isInternalPage() {
      return this.$route.name !== "Home";
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route() {
      this.$refs.loadingBar.startLoading();
      setTimeout(() => {
        this.$refs.loadingBar.stopLoading();
      }, 1000);
    },
    language() {
      if (this.language && this.language.length > 0) {
        const find = this.language.find((z) => z.codeKey === this.$route.path.substring(1));
        if (find) {
          this.languageId = find.id;
          localStorage.setItem("languageId", find.id);
          this.reloadData();
        }
      }
    },
  },
  metaInfo: {
    titleTemplate: process.env.VUE_APP_BASE_TITLE,
    meta: [{ charset: "utf-8" }],
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector("#dropdownAvatarName");
      const button = this.$el.querySelector("button");

      if (dropdown && !dropdown.contains(event.target) && !button.contains(event.target)) {
        this.dropdownVisible = false;
      }
    },
    setLanguage(data) {
      this.languageId = data.id;
      this.reloadData();
      localStorage.setItem("languageId", data.id);
      this.$router.push({
        name: "Home",
        params: { lang: data.codeKey },
      });
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight;
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 0;
      done();
    },
    toggleDarkMode(event) {
      if (event.target.checked) {
        document.querySelector("html").classList.add("dark");
        localStorage.setItem("darkMode", "enabled");
      } else {
        document.querySelector("html").classList.remove("dark");
        localStorage.setItem("darkMode", "disabled");
      }
    },
    reloadData() { },
  },
  mounted() {
    this.$store.dispatch("baseX/getLanguage");
    document.addEventListener("click", this.handleClickOutside);
    const darkMode = localStorage.getItem("darkMode");
    if (darkMode === "enabled") {
      document.querySelector("html").classList.add("dark");
      this.$refs.darkModeCheckbox.checked = true;
    }
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none !important;
  }
}
</style>
